import * as Yup from 'yup'
import LookupType from './LookupType'

export const WarrantyScheduleSchema = Yup.object().shape({
    job_detail_id: Yup
        .string(),

    field_worker: Yup.array().of(
        LookupType
            .label('Field Worker')
            .default(null)
            .nullable(),
    ).label('Field Worker')
    .required(),

    start: Yup
        .string()
        .nullable(),

    end: Yup
       .string()
        .nullable()
})